import Header from './Header'

const HeaderContainer = ({ themeColor, switchTheme, switchLanguage }) => {

    return <Header themeColor={themeColor} switchTheme={switchTheme} />
}

export default HeaderContainer